import { registerView, View, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import * as React from "react";
import Form from "react-bootstrap/Form";
import EmailInputViewModel from "viewModels/chargeManagement/chargeManagementEdit/common/emailInputViewModel";
import EmailInput from "views/common/emailInput/emailInput";

const EmailInputView: ViewComponent<EmailInputViewModel> = observer(({ vm }) => {
  return (
    <>
      <Form.Row>
        <EmailInput translate={vm.translate} target={vm.inputEmail} property="email" disablePaste={true} xl={12} />
        <EmailInput
          translate={vm.translateConfirmation}
          target={vm.inputEmail}
          property="emailConfirmation"
          disablePaste={true}
          xl={12}
        />
      </Form.Row>
      {vm.emailUsageInfo && <label>{vm.emailUsageInfo}</label>}
      <View vm={vm.gdprViewModel} />
    </>
  );
});

registerView(EmailInputView, EmailInputViewModel);
